<template lang="pug">
div(v-if="moduleInfo.rideCardInfoDTO")
  .my-ride-card(
    v-if="moduleInfo.rideCardInfoDTO.businessId === 1 && \
    (env.isEasyBikeApp || moduleInfo.twoRoundsCardholderUpgrades)"
  )
    .card-header(@click="goMycard")
      span 我的卡
      .my-card-right()
        .right-word {{moduleInfo.ownedCardCount?`全部${moduleInfo.ownedCardCount}张卡`:'全部卡'}}
        .right-icon
          img(src="https://m.hellobike.com/resource/gallery/61/YLPHa7dt_Group%20408.png")
    myCardTemplate.card-template(
      :moduleData="moduleInfo"
      :isUpgrade="moduleInfo.twoRoundsCardholderUpgrades"
      @buyUpgrade="buyUpgrade"
    )
  .my-card-container(
    v-else
    :class="moduleInfo.rideCardInfoDTO?'':'container-small'"
    @click="goMycard"
  )
    .my-card-left
      .my-card-title 我的骑行卡
      .my-card-subtitle(v-if="moduleInfo.rideCardInfoDTO")
        span {{moduleInfo.rideCardInfoDTO.businessId === 1?'单车':'助力车'}}
        span {{getValue()}}
        span {{getDays()}}
    .my-card-right()
      .right-word {{moduleInfo.ownedCardCount?`全部${moduleInfo.ownedCardCount}张卡`:'全部卡'}}
      .right-icon
        img(src="https://m.hellobike.com/resource/gallery/61/YLPHa7dt_Group%20408.png?x-oss-process=image/quality,q_80")
  buyCardWord(v-if="!newH5Version()")
</template>
<script>
import { env } from '@hb/hbridge';
import config from '@/const/config';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import buyCardWord from './buy-card-word';
import myCardTemplate from './my-card-template';
import { ParamsUtil } from '../../../../../utils/params';

export default {
  components: {
    buyCardWord,
    myCardTemplate,
  },
  props: {
    moduleData: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  inject: ['newH5Version'],
  data() {
    return {
      env,
      moduleInfo: {},
    };
  },
  watch: {
    moduleData: {
      deep: true,
      immediate: true,
      handler(val) {
        this.moduleInfo = val || {};
      },
    },
  },
  mounted() {
    UBT.moduleExpose({
      pageId: 'platform_openedcard_page',
      categoryId: 'platform',
      moduleId: 'platform_VIPmycard',
      contentId: 'platform_VIPmycard',
      exposureTimes: 1,
      businessInfo: {},
    });
    const { tabCode } = ParamsUtil.getParams(window.location.href);
    this.tabCode = tabCode || 'bike';
    // this.moduleInfo = this.moduleData;
  },
  methods: {
    getValue() {
      if (this.moduleInfo.rideCardInfoDTO && this.moduleInfo.rideCardInfoDTO.useProperty) {
        return `${this.moduleInfo.rideCardInfoDTO.useProperty.totalCardDays}天${this.moduleInfo.rideCardInfoDTO.useProperty.totalCardTimes ? this.moduleData.rideCardInfoDTO.useProperty.totalCardTimes : '不限'
        }次卡`;
      }
      return '';
    },
    getDays() {
      if (this.getValue().includes('不限次卡')) {
        return `，剩${this.moduleInfo.rideCardInfoDTO.remainDays}天`;
      }
      return `，剩${this.moduleInfo.rideCardInfoDTO.useProperty.remainCardTimes}次`;
    },
    goMycard() {
      UBT.clickButton({
        pageId: 'platform_openedcard_page',
        buttonName: 'platform_VIPmycard',
        categoryId: 'platform',
        businessInfo: {},
      });
      if (env.isEasyBikeApp) {
        window.location.href = 'hellobike://hellobike.com/moped/business/htr_my_card_page';
      } else {
        window.location.href = `https://m.hellobike.com/AppHelloBikeMainH5/${config.env !== 'pro' ? `${config.env}/` : ''
        }latest/index.html#/my-cards?adsource=`;
      }
    },
    buyUpgrade() {
      this.moduleData.current = this.moduleData.price;
      this.moduleData.original = this.moduleData.markedPrice;
      this.$emit('buyUpgrade', this.moduleData);
    },
  },
};
</script>
<style lang="less" scoped>
.my-card-container {
  margin: 0.12rem;
  height: 0.6rem;
  border-radius: 0.12rem;
  background: #fff;
  border: 0.5px solid #b2dbff;
  padding: 0.1rem 0.15rem 0 0.15rem;
  display: flex;
  justify-content: space-between;

  .my-card-left {
    .my-card-title {
      font-family: PingFangSC-Regular, PingFang SC, sans-serif;
      font-size: 0.16rem;
      font-weight: 500;
      line-height: 0.224rem;
      color: #242729;
    }

    .my-card-subtitle {
      margin-top: 0.04rem;
      font-family: PingFangSC-Regular, PingFang SC, sans-serif;
      font-size: 0.12rem;
      font-weight: 400;
      line-height: 0.168rem;
      color: #879099;
    }
  }

  .my-card-right {
    display: flex;
    margin-top: 0.12rem;
    font-family: PingFangSC-Regular, PingFang SC, sans-serif;
    font-size: 0.12rem;
    font-weight: 400;
    line-height: 0.168rem;
    color: #5a6066;

    .right-icon {
      img {
        width: 0.1rem;
        height: 0.1rem;
      }
    }
  }
}

.container-small {
  height: 0.39rem;
  padding: 0 0.15rem;
  line-height: 0.39rem;

  .my-card-right {
    margin-top: 0.11rem;
  }

  .my-card-left {
    .my-card-title {
      line-height: 0.39rem;
    }
  }
}

.my-ride-card {
  position: relative;
  font-family: PingFangSC-Regular, PingFang SC, sans-serif;
  margin: 0 0.2rem;

  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    font-size: 0.16rem;
    font-weight: 500;
    margin-bottom: 0.08rem;
    margin-top: 0.18rem;
    font-family: PingFangSC-Medium, PingFang SC, sans-serif;

    span {
      height: 0.22rem;
      line-height: 0.22rem;
    }

    .my-card-right {
      display: flex;
      font-family: PingFangSC-Regular, PingFang SC, sans-serif;
      font-size: 0.12rem;
      font-weight: 400;
      line-height: 0.168rem;
      color: #5a6066;

      .right-icon {
        img {
          width: 0.1rem;
          height: 0.1rem;
        }
      }
    }
  }

  .card-template {
    margin-bottom: 0.24rem;
  }
}
</style>
